export default "__VITE_ASSET__CfKuJOIe__"